//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sensitiveListApi } from '@/api/systemadmin';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
export default {
  data: function data() {
    return {
      tableData: {},
      tableFrom: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listLoading: false
    };
  },
  mounted: function mounted() {
    if (checkPermi(['distribution:log:sensitive:list'])) this.getLogList();
  },
  methods: {
    getLogList: function getLogList() {
      var _this = this;
      this.listLoading = true;
      sensitiveListApi(this.tableFrom).then(function (res) {
        _this.tableData = res;
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getLogList();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getLogList();
    }
  }
};